import store from "./../store";

export default class {
  constructor(http) {
    this.http = http;
  }

  addAttachment(file, func) {
    const campaignName = window.location.hash
      .split("&")
      .find((h) => h.includes("campaign"))
      .split("=")[1];

    const index = store.state.findIndex(
      (e) => e.configuration.campaign === campaignName
    );

    let fileSplit = file.name.split(".");
    let extensions = [
      "doc",
      "txt",
      "docm",
      "docx",
      "dot",
      "ppt",
      "pptm",
      "pptx",
      "psd",
      "pst",
      "tif",
      "tiff",
      "xlsx",
      "dotx",
      "pdf",
      "xls",
      "zip",
      "wav",
      "mp3",
      "mp4",
      "avi",
      "mpeg",
      "mpg",
      "png",
      "jpg",
      "jpeg",
      "gif",
      "bmp",
      "csv",
      "m4a",
      "mov",
    ];

    let fileExt = fileSplit[fileSplit.length - 1];
    if (!extensions.includes(fileExt.toLowerCase())) return "invalidextension";

    if (file.size > 10240000) return "maxfilesize10mb";
    this.convertirB64(file, (b64) => {
      this.http
        .post(
          "https://" +
            store.state[index].configuration.ip +
            "/IntegraChannels/resources/webchat/addAttachment",
          b64,
          {
            headers: {
              "Content-type": "application/x-www-form-urlencoded",
            },
            params: {
              filename: file.name.replace(/[^a-zA-Z0-9.]/g, "_"),
            },
          }
        )
        .then(
          (e) => {
            if (e.status === 200) {
              func(this.getFileType(file) + "|" + JSON.parse(e.bodyText)[0]);
            }
          },
          (e) => {
            //error
          }
        );
    });

    return true;
  }

  getFileType(file) {
    var type = file.type;
    if (type.indexOf("image") > -1) return "image";
    else return type.split("/")[0];
  }

  convertirB64(archivo, funcion) {
    let reader = new FileReader();
    reader.onload = (readerEvt) => {
      let b64 = btoa(readerEvt.target.result);
      funcion(this.checkB64(b64));
    };
    reader.readAsBinaryString(archivo);
  }

  checkB64(b64) {
    let menor = 0;
    if (b64.length % 4 != 0) menor = 4 - (b64.length % 4);
    for (let i = 0; i < menor; i++) {
      b64 += "=";
    }
    return b64;
  }
}
